/*******************************************************************************
 * Copyright     : Copyright (c)  2024 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/

//@Dark theme value "0" and Light theme value "1"
export const DARK_THEME = "0";
export const DEFAULT_LOCALE_LANGUAGE = "enUS";

export const BASIC_INFO_MIN_CHARS = 3;
export const BASIC_INFO_MAX_CHARS = 50;

export const emailText = "Honeywell support team";
export const orgSiteStatusNameLists = ["CbSiteId", "EomSiteId"];
export const orgStatusLists = ["onboardingStatus", "inProgressStatus", "failedStatus", "completedStatus"];

export const IS_STANDALONE = "is_standalone";
export const AD_ORGANIZATION_ID = "FC123456789101112";
export const RBM_ACCESS_TOKEN_STORAGE_NAME = "rbm_access_token";
export const GATEWAY_TOKEN_STORAGE_NAME = "iot_devices_access_token";
export const IAM_PROJECT_ID_SESSION_TOKEN_STORAGE_NAME = "selectedOrg";

export const EBI_GATEWAY_TYPE = "EBI";
export const EBI_FOLDER_USED_TO_REGISTER = "Global > HCE FORGE";

export const NO_HOST_REF_KEY = "No-Host-Ref-Value";

export const ROUTE_PATH = {
	standAloneLanding: "/",
	deviceslist: "/devices-list",
	createDevice: "/create-device",
	editDevice: "/edit-device",
	viewDevice: "/view-device",
	landingPage: "/",
	reRegistration: "/re-registration",
	bulkAssignment: "/bulk-assignment",
	logout: "/logout"
};

export const OVERVIEW_TAB_STRINGS = {
	OVERVIEW: "overview",
	REPORT: "report",
	LINKED_DEVICES: "linkedDevices",
	REMOTE_CONNECT: "remoteConnect",
	CONNECT: "connect",
};

export const OVERVIEW_TAB_IDS = {
	OVERVIEW: "overview",
	LINKED_DEVICES: "linkedDevices",
	REPORT: "report",
	REMOTE_CONNECT: "remote-connect",
	CONNECT: "connect",
};

export const VIEW_DEVICE_OVERVIEW = {
	PUBLISH_FREQUENCY: "Publish Frequency",
	SELECT_AN_OPTION: "Select an option",
	BASIC_INFO: "Basic Information",
	ASSOCIATION_DETAILS: "Registration Details",
	HEALTH_DETAILS: "Health Details",
	CONFIGURATION: "Configuration",
	SAVE: "save",
	VIEW_GATEWAY: "viewGateway",
	EDIT: "edit"
};

export const GatewayStatus = {
	Active: "CONNECTED",
	Deleting: "DELETING",
	Error: "DISCONNECTED",
	Activating: "ACTIVATING",
	Deactivated: "DEACTIVATED",
	Deactivating: "DEACTIVATING",
	Pending: "REGISTRATION_PENDING",
	CertificateExpired: "CERTIFICATE_EXPIRED"
};

export const LinkedDeviceStatus = {
	Connected: "ONLINE",
	Disconnected: "OFFLINE",
	Unstable: "MARGINAL"
};

export const DeviceLinkedStatus = {
	ONLINE: "Connected",
	OFFLINE: "Disconnected",
	MARGINAL: "Unstable"
};

//@Locale Constants
export const LOCALE_CONST = {
	create: "create",
	remoteAccess: "remoteAccess",
	gateway: "gateway",
	logout: "logout",
	gatewayManagement: "gatewayManagement",
	gatewayManagementSubtext: "gatewayManagementSubtext",
	active: "active",
	error: "error",
	pending: "pending",
	deleting: "deleting",
	activating: "activating",
	deactivating: "deactivating",
	deactivated: "deactivated",
	certificateExpired: "certificateExpired",
	connected: "connected",
	unstable: "unstable",
	disconnected: "disconnected",
	edit: "edit",
	report: "report",
	overview: "overview",
	linkedDevices: "linkedDevices",
	remoteConnect: "remoteConnect",
	viewGateway: "viewGateway",
	remoteUrl: "remoteUrl",
	remoteConnection: "remoteConnection",
	noReportsAvail: "noReportsAvail",
	orgMandate: "orgMandate",
	selectedSiteFailedMsg: "selectedSiteFailedMsg",
	reportDownload: "reportDownload",
	reportRunDiagnosticsButtonLabel: "reportRunDiagnosticsButtonLabel",
	reportTriggerTime: "reportTriggerTime",
	reportStatus: "reportStatus",
	reportRunDiagnosticsModalTitle: "reportRunDiagnosticsModalTitle",
	reportRunDiagnosticsModalContent: "reportRunDiagnosticsModalContent",
	reportFetchLogs: "reportFetchLogs",
	reportLogs: "reportLogs",
	reportConfigData: "reportConfigData",
	reportFetchConfigData: "reportFetchConfigData",
	reportFetchConfigDataModalContent: "reportFetchConfigDataModalContent",
	reportRemoteAccessAndMonitor: "reportRemoteAccessAndMonitor",
	reportGoToAzureArcPortalLink: "reportGoToAzureArcPortalLink",
	reportRemoteAccessAndMonitorDesc: "reportRemoteAccessAndMonitorDesc",
	reportRegenerateKeyDesc: "reportRegenerateKeyDesc",
	reportGenerateNewKeyButtonText: "reportGenerateNewKeyButtonText",
	reportCopyText: "reportCopyText",
	reportCopiedText: "reportCopiedText",
	reportExpiresOnText: "reportExpiresOnText",
	reportExpiredText: "reportExpiredText",
	reportLoadingDiagnosticText: "reportLoadingDiagnosticText",
	reportErrorDiagnosticText: "reportErrorDiagnosticText",
	reportNoConfigFilesFound: "reportNoConfigFilesFound",
	reportAnErrOccurred: "reportAnErrOccurred",
	reportDiagnostics: "reportDiagnostics",
	reportNoDiagnosticsFilesFound: "reportNoDiagnosticsFilesFound",
	reportConfigDataDesc: "reportConfigDataDesc",
	reportDiagnosticsDesc: "reportDiagnosticsDesc",
	reportStartDateLabel: "reportStartDateLabel",
	reportEndDateLabel: "reportEndDateLabel",
	search: "search",
	gatewayOverview: "gatewayOverview",
	createNewGateway: "createNewGateway",
	basicInfo: "basicInfo",
	name: "name",
	save: "save",
	cancel: "cancel",
	confirm: "confirm",
	enterRegKey: "enterRegKey",
	existingGateway: "existingGateway",
	optional: "optional",
	langNameConvention: "langNameConvention",
	enterSystemGUID: "enterSystemGUID",
	downloadReport: "downloadReport",
	gatewayType: "gatewayType",
	systemGUID: "systemGUID",
	softwareVersion: "softwareVersion",
	firmwareVersion: "firmwareVersion",
	gatewayVersion: "gatewayVersion",
	registeredOn: "registeredOn",
	editGateway: "editGateway",
	organization: "organization",
	upgradeCurrGateway: "upgradeCurrGateway",
	systemID: "systemID",
	registrationDetails: "registrationDetails",
	searchByName: "searchByName",
	associatedSites: "associatedSites",
	associateSite: "associateSite",
	activate: "activate",
	deactivate: "deactivate",
	delete: "delete",
	manufacturer: "manufacturer",
	model: "model",
	pointCount: "pointCount",
	description: "description",
	historyCount: "historyCount",
	scheduleCount: "scheduleCount",
	hostOSVersion: "hostOSVersion",
	cloudIdMaxCount: "cloudIdMaxCount",
	alarmSourceCount: "alarmSourceCount",
	hostSerialNumber: "hostSerialNumber",
	supervisorUseCount: "supervisorUseCount",
	supervisorLicensedCount: "supervisorLicensedCount",
	rowsPerPage: "rowsPerPage",
	goToPage: "goToPage",
	numberOfItems: "numberOfItems",
	site: "site",
	reset: "reset",
	apply: "apply",
	status: "status",
	filter: "filter",
	actions: "actions",
	contact: "contact",
	important: "important",
	searchSites: "searchSites",
	systemNumber: "systemNumber",
	clearFilters: "clearFilters",
	searchColumns: "searchColumns",
	noSitesFound: "noSitesFound",
	loading: "loading",
	loadingDetails: "loadingDetails",
	showAllColumns: "showAllColumns",
	customizeColumns: "customizeColumns",
	invalidCharacter: "invalidCharacter",
	noSearchDataFound: "noSearchDataFound",
	noGatewayTypeFound: "noGatewayTypeFound",
	noOrgFound: "noOrgFound",
	systemIntegrator: "systemIntegrator",
	requiredField: "requiredField",
	undoneAction: "undoneAction",
	forbidAuthFails: "forbidAuthFails",
	unAuthFails: "unAuthFails",
	badRequest: "badRequest",
	projectIDNotFound: "projectIDNotFound",
	customizeColumnsSubText: "customizeColumnsSubText",
	manualKeyGenerText: "manualKeyGenerText",
	internalServerError: "internalServerError",
	gatewayNameValidText: "gatewayNameValidText",
	deactivateInfoNote: "deactivateInfoNote",
	type: "type",
	success: "success",
	refresh: "refresh",
	untitled: "untitled",
	protocol: "protocol",
	modelName: "modelName",
	reloadPage: "reloadPage",
	vendorName: "vendorName",
	assignSites: "assignSites",
	triggerModal: "triggerModal",
	deleteGateway: "deleteGateway",
	searchOrg: "searchOrg",
	selectOrg: "selectOrg",
	clearSelection: "clearSelection",
	itemSelectedText: "itemSelectedText",
	activateDevice: "activateDevice",
	revokeAuth: "revokeAuth",
	protocolRevision: "protocolRevision",
	orgNotFound: "orgNotFound",
	firmwareRevision: "firmwareRevision",
	noSitesSelected: "noSitesSelected",
	deactivateDevice: "deactivateDevice",
	noGatewayCreated: "noGatewayCreated",
	noDevicesFound: "noDevicesFound",
	noResultFoundText: "noResultFoundText",
	gwConnectionFailed: "gwConnectionFailed",
	notSaveGWDetails: "notSaveGWDetails",
	actionCannotBeDone: "actionCannotBeDone",
	somethingWentWrong: "somethingWentWrong",
	deleteConfirmText: "deleteConfirmText",
	AuthForbidFails: "AuthForbidFails",
	gwConnectionFailedAt: "gwConnectionFailedAt",
	siteValidation: "siteValidation",
	migrateGWConfirmation: "migrateGWConfirmation",
	enterValidSystemGUID: "enterValidSystemGUID",
	regKeyValidation: "regKeyValidation",
	noResultsFound: "noResultsFound",
	gwNameValidation: "gwNameValidation",
	deviceTypeConfirmation: "deviceTypeConfirmation",
	associateSiteOnClick: "associateSiteOnClick",
	orgListFailed: "orgListFailed",
	noOrgAssociated: "noOrgAssociated",
	orgOnboardingStatus: "orgOnboardingStatus",
	clientIDMandate: "clientIDMandate",
	deviceCodeClaimed: "deviceCodeClaimed",
	authPending: "authPending",
	regKeySucces: "regKeySucces",
	regKeyExpired: "regKeyExpired",
	regKeyClaimed: "regKeyClaimed",
	noReqTLSCertificate: "noReqTLSCertificate",
	proDoesnotExist: "proDoesnotExist",
	proIDDoesnotExist: "proIDDoesnotExist",
	gwDetailsNotFound: "gwDetailsNotFound",
	orgIDandNameRequired: "orgIDandNameRequired",
	noRouteMatched: "noRouteMatched",
	multiGWSiteAssignBadReq: "multiGWSiteAssignBadReq",
	enrollFailedMsg: "enrollFailedMsg",
	invalidTextMessage: "invalidTextMessage",
	fieldRequired: "fieldRequired",
	errReadCertFile: "errReadCertFile",
	orgInProgressStatsMsg: "orgInProgressStatsMsg",
	siteFailedStatsMsg: "siteFailedStatsMsg",
	orgFailedStatsMsg: "orgFailedStatsMsg",
	retryText: "retryText",
	hwSupportTeam: "hwSupportTeam",
	revokeGateway: "revokeGateway",
	revoke: "revoke",
	deleteMapConfirm: "deleteMapConfirm",
	deleteConfirmation: "deleteConfirmation",
	revokeConfirmation: "revokeConfirmation",
	revokeSuccess: "revokeSuccess",
	revokeError: "revokeError",
	revokeErrorText: "revokeErrorText",
	sites: "sites",
	language: "language",
	overwriteSites: "overwriteSites",
	errCode: "errCode",
	tryReloading: "tryReloading",
	notFound: "notFound",
	noPageFound: "noPageFound",
	resourceNotFound: "resourceNotFound",
	forbidden: "forbidden",
	accessDenied: "accessDenied",
	badGateway: "badGateway",
	badGatewayTry: "badGatewayTry",
	badRequestText: "badRequestText",
	invalidReqInput: "invalidReqInput",
	unauthorized: "unauthorized",
	unauthAccess: "unauthAccess",
	gatewayTimeout: "gatewayTimeout",
	gatewayTimeoutTry: "gatewayTimeoutTry",
	serviceUnavailable: "serviceUnavailable",
	serviceUnavailableTry: "serviceUnavailableTry",
	internalServerErrorText: "internalServerErrorText",
	serverErrorTryText: "serverErrorTryText",
	noRespReceived: "noRespReceived",
	noRespReceivedSystem: "noRespReceivedSystem",
	bulkAssignment: "bulkAssignment",
	backToGateways: "backToGateways",
	unknownError: "unknownError",
	failedSaveGateway: "failedSaveGateway",
	gwDetailsUpdatedSuccess: "gwDetailsUpdatedSuccess",
	assignSitesError: "assignSitesError",
	failedPerformAction: "failedPerformAction",
	siteAssignedSuccess: "siteAssignedSuccess",
	gwNameSuccessCreate: "gwNameSuccessCreate",
	gwNameSuccessReRegistration: "gwNameSuccessReRegistration",
	gwAssociation: "gwAssociation",
	unAuthAccessText: "unAuthAccessText",
	badRequestGWID: "badRequestGWID",
	certAlreadyExpired: "certAlreadyExpired",
	forbidAccessDenied: "forbidAccessDenied",
	notFoundGWInvalid: "notFoundGWInvalid",
	deleteFailed: "deleteFailed",
	deleteSuccess: "deleteSuccess",
	activatedSuccess: "activatedSuccess",
	deactivatedSuccess: "deactivatedSuccess",
	conflictGWAlreadyRevoked: "conflictGWAlreadyRevoked",
	badGatewayTryAgainLater: "badGatewayTryAgainLater",
	serviceUnavailTryAgainLater: "serviceUnavailTryAgainLater",
	gwTimeoutRequestTryAgainLater: "gwTimeoutRequestTryAgainLater",
	overwrittenAssignSiteMap: "overwrittenAssignSiteMap",
	gwNameAlreadyExists: "gwNameAlreadyExists",
	nonModifySiteLinked: "nonModifySiteLinked",
	orgAndSiteOneTimeActionText: "orgAndSiteOneTimeActionText",
	gwBelongsDifferentOrgWarn: "gwBelongsDifferentOrgWarn",
	actionNotAllowed: "actionNotAllowed",
	notAllowedSelecDevices: "notAllowedSelecDevices",
	editMultiSiteModalDesc: "editMultiSiteModalDesc",
	editSingleSiteModalDesc: "editSingleSiteModalDesc",
	eidtConfirmationText: "eidtConfirmationText",
	localPort: "localPort",
	portUsage: "portUsage",
	enterPort: "enterPort",
	enterPortUsage: "enterPortUsage",
	removePort: "removePort",
	gatewayPorts: "gatewayPorts",
	gatewayConnectivity: "gatewayConnectivity",
	localGatewayIP: "localGatewayIP",
	macID: "macID",
	gatewayWebURL: "gatewayWebURL",
	remoteAgentHealth: "remoteAgentHealth",
	authorise: "authorise",
	authorised: "authorised",
	notAuthorised: "notAuthorised",
	addPort: "addPort",
	noDataAvailForPagination: "noDataAvailForPagination",
	devices: "devices",
	addDevicePort: "addDevicePort",
	removeDevicePort: "removeDevicePort",
	authorize: "authorize",
	definePortForConnecion: "definePortForConnecion",
	add: "add",
	removalWishConfirm: "removalWishConfirm",
	confirmAuthorisation: "confirmAuthorisation",
	portAuthConfirmation: "portAuthConfirmation",
	revokeAuthorisation: "revokeAuthorisation",
	revokeAuthorisationConfirmation: "revokeAuthorisationConfirmation",
	activeConnections: "activeConnections",
	disconnect: "disconnect",
	downloadClient: "downloadClient",
	noGatewayAvailable: "noGatewayAvailable",
	associateGateway: "associateGateway",
	gatewayConfirmationTitle: "gatewayConfirmationTitle",
	gatewayConfirmationText: "gatewayConfirmationText",
	editSiteModalDescOne: "editSiteModalDescOne",
	editSiteModalDescTwo: "editSiteModalDescTwo",
	noSecureConnectEBIURL: "noSecureConnectEBIURL",
	downloadClientSuccess: "downloadClientSuccess",
	downloadClientError: "downloadClientError",
	connect: "connect",
	bannerAssigningMultiSites: "bannerAssigningMultiSites",
	clientError_400: "clientError_400",
	clientError_401: "clientError_401",
	clientError_403: "clientError_403",
	clientError_404: "clientError_404",
	clientError_409: "clientError_409",
	clientError_429: "clientError_429",
	serverError_500: "serverError_500",
	serverErroe_502: "serverErroe_502",
	serverError_503: "serverError_503",
	serverError_504: "serverError_504",
	errFetchingRegKey: "errFetchingRegKey",
	activateFailed: "activateFailed",
	deactivateFailed: "deactivateFailed",
	failedSyncType: "failedSyncType",
	assocGateway: "assocGateway",
	badRequest_rt: "badRequest_rt",
	unauthorized_rt: "unauthorized_rt",
	forbidden_rt: "forbidden_rt",
	notFound_rt: "notFound_rt",
	conflict_rt: "conflict_rt",
	internalServerError_rt: "internalServerError_rt",
	badRequest_gc_400: "badRequest_gc_400",
	unauthorized_gc_401: "unauthorized_gc_401",
	forbidden_gc_403: "forbidden_gc_403",
	notFound_gc_404: "notFound_gc_404",
	internalServerError_gc_500: "internalServerError_gc_500",
	badRequest_ac_400: "badRequest_ac_400",
	unauthorized_ac_401: "unauthorized_ac_401",
	forbidden_ac_403: "forbidden_ac_403",
	notFound_ac_404: "notFound_ac_404",
	internalServerError_ac_500: "internalServerError_ac_500",
	badRequest_ld_400: "badRequest_ld_400",
	unauthorized_ld_401: "unauthorized_ld_401",
	forbidden_ld_403: "forbidden_ld_403",
	notFound_ld_404: "notFound_ld_404",
	internalServerError_ld_500: "internalServerError_ld_500",
	success_ap_200: "success_ap_200",
	success_ap_device_200: "success_ap_device_200",
	badRequest_ap_400: "badRequest_ap_400",
	unauthorized_ap_401: "unauthorized_ap_401",
	forbidden_ap_403: "forbidden_ap_403",
	notFound_ap_404: "notFound_ap_404",
	conflict_ap_409: "conflict_ap_409",
	internalServerError_ap_500: "internalServerError_ap_500",
	success_rp_200: "success_rp_200",
	badRequest_rp_400: "badRequest_rp_400",
	unauthorized_rp_401: "unauthorized_rp_401",
	forbidden_rp_403: "forbidden_rp_403",
	notFound_rp_404: "notFound_rp_404",
	internalServerError_rp_500: "internalServerError_rp_500",
	success_approve_200: "success_approve_200",
	success_block_200: "success_block_200",
	badRequest_app_block_400: "badRequest_app_block_400",
	unauthorized_app_block_401: "unauthorized_app_block_401",
	forbidden_app_block_403: "forbidden_app_block_403",
	notFound_app_block_404: "notFound_app_block_404",
	conflict_app_block_409: "conflict_app_block_409",
	internalServerError_app_block_500: "internalServerError_app_block_500",
	"404InvalidRegKey": "404InvalidRegKey",
	"404RegNotFound": "404RegNotFound",
	warning: "warning",
	nameplateNotConfigured: "nameplateNotConfigured",
	unauthorized_dc_401: "unauthorized_dc_401",
	forbidden_dc_403: "forbidden_dc_403",
	notFound_dc_404: "notFound_dc_404",
	internalServerError_dc_500: "internalServerError_dc_500",
	reregister: "reregister",
	legacy: "legacy"
};